import axios from "../../../axios";
import { getCurrentTenant } from '@/utils';

export default {
    loginSSO(code, redirectUri, ip = '') {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
            mutation {
                loginSSO (
                    code: "${code}",
                    redirect_uri: "${redirectUri}",
                    ip: "${ip}"
                ) {
                    token,
                    user {
                        id,
                        name,
                        username,
                        email,
                        image,
                        managed_by_database_connection
                        isConnected,
                        twofactor_activity,
                        is_two_factor_validated,
                        role {
                            id,
                            name,
                            display_name,
                            has_permission_routes
                        }
                    }
                }
            }
          `
        });
    }
}